<template>
  <img
    :src="logo"
    alt="Elective Logo"
  >
</template>

<script setup lang="ts">
import logo from '@/assets/images/elective_full.svg';
</script>
